/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import * as styles from "../FormPreview.module.css";
import { ReadOnlyFormItem, useGenerateLocalizedStringsMap } from "./appInfoModelsAndHelpers";
import * as rowStyles from "./ApplicationInformationRow.module.css";
import { ApplicationInformationSharedRowContent } from "./ApplicationInformationSharedRowContent";

type ReadOnlyFormProps = {
  formData: any;
  formConfig: Map<string, ReadOnlyFormItem>;
  extraStringsToLocalize?: string[];
  additionalData?: Map<string, any>;
};

export const ReadOnlyForm = ({
  formData,
  formConfig,
  extraStringsToLocalize,
  additionalData,
}: ReadOnlyFormProps) => {
  const stringsToLocalize = extraStringsToLocalize ? [...extraStringsToLocalize] : [];
  for (const entry of formConfig.entries()) {
    // Title takes precedence over config key for all items
    const stringToLocalize = entry[1].title ?? entry[0];
    stringsToLocalize.push(stringToLocalize);
  }
  const localizedStringsMap = useGenerateLocalizedStringsMap(stringsToLocalize);
  return (
    <div className={rowStyles.row}>
      <table className={styles.table} role="presentation">
        <tbody>
          {[...formConfig.entries()].map((keyValuePair, index) => {
            const config = keyValuePair[1];
            if (!config) {
              return null;
            }
            const key = keyValuePair[0];
            const mappedAnswer = config.mapper
              ? config.mapper(formData, localizedStringsMap, additionalData)
              : formData[key];
            const localizedStringKey = localizedStringsMap.get(config?.title ?? key) ?? "";
            return mappedAnswer ? (
              <ApplicationInformationSharedRowContent
                question={localizedStringKey}
                answers={mappedAnswer}
                isAnswerWithHtmlContent={config.isAnswerWithHtmlContent}
                id={`${key}${index}`}
                key={index}
              />
            ) : null;
          })}
        </tbody>
      </table>
    </div>
  );
};
